/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ position: NonNullable<unknown> }} Agenda_Journey_Suggestion_Pill_ShortInputs */



/**
* | output |
* | --- |
* | "Step {position}?" |
*
* @param {Agenda_Journey_Suggestion_Pill_ShortInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const agenda_journey_suggestion_pill_short = /** @type {((inputs: Agenda_Journey_Suggestion_Pill_ShortInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agenda_Journey_Suggestion_Pill_ShortInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Stap ${i?.position}?`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Étape ${i?.position} ?`)
	return /** @type {LocalizedString} */ (`Step ${i?.position}?`)
});